<template>
  <div class="bg-light">
    <div class="main-width">
      <div class="my-5">
        <VBreadcrumb :options="breadcrumbs"/>
      </div>

      <div :class="$style.header">
        <ProductCruiseInfo :cruiseInfo="state.cruises_info"/>
        <product-detail-head class="ml-7 flex-1" :title="state.title" :productNo="state.product_no" :levelPic="state.level_pic"
          :departure="state.departure" :departure-date="state.departure_date"
          :destination-date="state.destination_date" :destination="state.destination"
          :company-name="state.company_name" :company-logo="state.company_logo" :ports="state.ports"
          :cruiseInfo="state.cruises_info" :minSalePrice="state.min_sale_price"
          :minThPrice="state.min_th_price"
          :status="state.status"
          :tags="state.product_tags"
          :cruise-product-type="state.cruise_product_type"
          :is-favorite="isFavorite"
          :is-open-shop="isOpenShop"
          :is-in-shop="isInShop"
          @share="handleShareShopProduct"
          @favorite="onToggleFavorite"
          @join="onJoinShop"
        />
      </div>
      <div ref="containerRef" class="j_content">
        <VSticky :class="$style.scrollNav_container" :offsetTop="stickyOffsetTop" @change="isSticky = $event">
          <scroll-active :class="[$style.scrollNav, isSticky ? $style.scrollNav_fixed : '']" highlight-first-item
                         tag="ul" :activeClass="$style.isActive"
                         :offset="offsetTop">
            <li :class="[$style.scrollNav_item, $style.isActive]" class="scrollactive-item is-active"
                data-section-selector=".j_product-date">
              出发日期
            </li>
            <li v-if="state.tour.length || state.trip_image" :class="$style.scrollNav_item"
                class="scrollactive-item" data-section-selector=".j_product-trip">
              行程
            </li>
            <li v-if="state.fee_description.include || state.fee_description.not_include"
                :class="$style.scrollNav_item" class="scrollactive-item" data-section-selector=".j_product-fee">
              费用说明
            </li>
            <li v-if="state.booking_notice" :class="$style.scrollNav_item" class="scrollactive-item"
                data-section-selector=".j_product-booking">
              预订须知
            </li>
            <li v-if="state.cancel_policy" :class="$style.scrollNav_item" class="scrollactive-item"
                data-section-selector=".j_product-cancel">
              取消政策
            </li>
            <li class="ml-auto flex items-center">
              <el-button type="default" :class="$style.tour_btn" @click="openMaterrialDiaog"
                         v-if="state.exists_material">
                <el-image :class="$style.material_icon" fit="contain"
                          src="@/assets/img/product/icon_product_material.png"></el-image>
                <span class="align-middle">营销素材</span>
              </el-button>
              <el-button type="default" :class="$style.tour_btn" plain @click="onDownloadTourFile">
                <i class="ficon ficon-wenjianxiazai1" :class="$style.font_24"></i>
                <em>行程文件下载</em>
              </el-button>
            </li>
          </scroll-active>
        </VSticky>

        <section-card title="出发日期" class="j_product-date items-center"
                      :subtitle="`${stockState.count}个出发日期可选`">
          <template #head-extra>
            <div class="ml-auto flex flex-col rounded bg-[#F25B3B] pb-[2px]">
              <v-alert class="!text-white" style="padding-left: 8px; padding-bottom: 0px;"
                       icon="ficon ficon-tanhaoxianxing" :message="message"></v-alert>
              <v-alert class="!text-white" style="padding-left: 22px; padding-top: 0px"
                       message="价格仅供参考，如需准确价格，请点击“预订”按钮获取"></v-alert>
            </div>
          </template>
          <product-detail-dates :count="stockState.count" :dates="stockState.date"
                                :cabins="stockState.title" :productNo="state.product_no" :offset-top="offsetTop"/>
        </section-card>

        <section-card v-if="state.tour.length || state.trip_image" title="行程" class="j_product-trip">
          <product-detail-route :tripImg="state.trip_image" :tours="state.tour"/>
        </section-card>

        <section-card title="费用说明" class="j_product-fee">
          <product-detail-fee :include="state.fee_description.include"
                              :notInclude="state.fee_description.not_include"/>
        </section-card>

        <section-card v-if="state.booking_notice" title="预订须知" class="j_product-booking">
          <product-detail-booking-notice :content="state.booking_notice"/>
        </section-card>

        <section-card v-if="state.cancel_policy" title="取消政策" class="j_product-cancel">
          <product-detail-cancel :content="state.cancel_policy"/>
        </section-card>
      </div>


      <ProductDetailTools
          v-if="state.status !== 0"
          :is-favorite="isFavorite"
          :is-open-shop="isOpenShop"
          :is-in-shop="isInShop"
          @share="handleShareShopProduct"
          @favorite="onToggleFavorite"
          @join="onJoinShop"
          :url="state.mini_code"
      />

      <!--分享店铺产品二维码-->
      <share-shop-product ref="shareShopProductRef"></share-shop-product>
      <product-material ref="productMaterialRef"/>

    </div>
  </div>
</template>
<script>
// composables
import {
  computed,
  defineComponent,
  ref,
  useContext,
  useFetch,
  useMeta,
  useRoute
} from "@nuxtjs/composition-api";

import {useElementSize} from "@vueuse/core";
import useRequest from "~/composables/useRequest";
import useLayout from "~/composables/useLayout";
import useProductFavorite from '~/views/product/composables/useProductFavorite';
import useProductJoinShop from '~/views/product/composables/useProductJoinShop';

// components
import ScrollActive from "@/components/ScrollActive";

import SectionCard from "~/components/automation/section-card.vue";

import ProductCruiseInfo from '@/components/automation/product-detail-cruise-info.vue'
// 产品信息
import ProductDetailHead from "~/components/automation/product-detail-head.vue";
// 出行安全协议
import ProductDetailAgreement from "~/components/automation/product-detail-agreement.vue";
// 出发日期
import ProductDetailDates from "~/components/automation/product-detail-dates.vue";
// 行程
import ProductDetailRoute from "~/components/automation/product-detail-route.vue";
// 费用
import ProductDetailFee from "~/components/automation/product-detail-fee.vue";
// 预订须知
import ProductDetailBookingNotice from "~/components/automation/product-detail-booking-notice.vue";
// 取消政策
import ProductDetailCancel from "~/components/automation/product-detail-cancel.vue";

import VAlert from '~/components/VAlert/index.vue'

import VSticky from '~/components/VSticky/index.vue'

import VBreadcrumb from '@/components/VBreadcrumb.vue'

import ProductDetailTools from '~/views/product/ProductDetailTools.vue'
import ShareShopProduct from "@/views/product/components/ShareShopProduct/index.vue";
import ProductMaterial from '@/components/product/product-material.vue'


// api
import {
  getAbroadCruiseDate,
  getAbroadCruiseInfo
} from "~/services/automation";
import {getRequirementsAgreementsDetail} from "~/services/company";
import combineURLs from "~/utils/combineURLs";

export default defineComponent({
  layout: "Main",
  components: {
    ProductDetailTools,
    ScrollActive,
    // VAffix,
    VSticky,
    VAlert,

    SectionCard,
    ProductCruiseInfo,
    ProductDetailHead,
    ProductDetailAgreement,
    ProductDetailDates,
    ProductDetailRoute,
    ProductDetailFee,
    ProductDetailBookingNotice,
    ProductDetailCancel,
    ShareShopProduct,
    VBreadcrumb,
    ProductMaterial
  },
  validate: ({params}) => /^P\d+$/.test(params.productNo),
  head: {},
  auth: false,
  setup() {
    const {store} = useContext();
    const route = useRoute();
    const {state, execute} = useRequest(
        getAbroadCruiseInfo,
        {
          id: "",
          status: undefined,
          status_label: "",
          class: "",
          class_id: "",
          class_label: "",
          product_no: "",
          min_th_price: "",
          min_sale_price: "",
          min_profit: "",
          max_profit: "",
          on_pier: "",
          departure_date: "",
          days: "",
          cruise_type: "",
          title: "",
          tags: [],
          product_tags:[],
          cruise_product_type: 1,
          images: [],
          route_city_image: "",
          departure: "",
          destination: "",
          level_pic: "",
          mini_code: "",
          cruises_info: {
            id: "",
            title: "",
            title_en: "",
            video: "",
            images: [],
            type: "",
            type_label: "",
            cover: "",
            tonnage: "",
            passenger: "",
            first_time: "",
            renovation_time: "",
            floor: "",
            length: "",
            width: "",
            speed: "",
            intro: "",
            describe: ""
          },
          features: "",
          feature_image: [],
          trip_image: "",
          tour: [],
          fee_description: {
            include: "",
            not_include: "",
            cost_not_include: ""
          },
          visa: {desc: "", images: [], files: []},
          booking_notice: "",
          cancel_policy: "",
          tips: "",
          trip_file: false,
          coupon_list: [],
          is_favorite: 0,
          in_shop: false,
          sales_info: [],
          policy: [],
          ports: []
        },
        {
          immediate: false
        }
    );
    const message = computed(() => {
      if (state.value.tax) {
        return '以下价格为2人入住同1间舱房的每人含税价格'
      } else return '以下价格为2人入住同1间舱房的每人价格'
    })
    const {state: stockState, execute: fetchDates} = useRequest(
        getAbroadCruiseDate,
        {
          count: 0,
          date: [],
          title: []
        },
        {
          immediate: false
        }
    );

    useFetch(async () => {
      const {productNo} = route.value.params;
      const res = await Promise.all([
        await execute(0, {
          product_no: productNo
        }),
        fetchDates(0, {
          product_no: productNo
        })
      ]);

      isFavorite.value = !!state.value.is_favorite;
      isInShop.value = !!state.value.in_shop;
    });

    useMeta(() => ({
      title: state.value.title
    }));

    const productNo = computed(() => state.value.product_no)
    // ======================= 收藏 =======================
    const {isFavorite, onToggleFavorite} = useProductFavorite(productNo)

    // ======================= 分享 =======================
    const shareShopProductRef = ref(null);
    const handleShareShopProduct = () => {
      shareShopProductRef.value.handleShareShopPrdouct({title: state.value.title, product_no: productNo.value});
    }
    const isOpenShop = computed(() => store.getters.isOpenShop)
    const {isInShop, onJoinShop} = useProductJoinShop(productNo);


    const {headerSize} = useLayout();
    const offsetTop = computed(() => headerSize.height + 64);
    const stickyOffsetTop = computed(() => {
      return headerSize.height
    })
    const isSticky = ref();

    const breadcrumbs = [
      {label: '首页', to: '/'},
      {label: '产品列表', to: '/product/automation/foreign-cruise-search'},
      {label: '产品详情'},
    ]
    const onDownloadTourFile = () => {
      const {productNo} = route.value.params;
      let href = combineURLs(window.location.origin, `/auto/product/trip-pdf?product_no=${productNo}`);
      window.open(href, "_blank");
    }

    const productMaterialRef = ref()

    const openMaterrialDiaog = () => {
      productMaterialRef.value.setData({
        product_no: route.value.params.productNo
      })
    }

    return {
      state,
      stockState,
      // argeementState,
      isSticky,
      offsetTop,
      stickyOffsetTop,
      breadcrumbs,
      onDownloadTourFile,


      shareShopProductRef,
      handleShareShopProduct,

      isFavorite,
      onToggleFavorite,


      isOpenShop,
      isInShop,
      onJoinShop,

      message,
      openMaterrialDiaog,
      productMaterialRef,
      // containerRef,
      // containerWidth
    };
  }
});
</script>
<style lang="scss" module>
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
  background: linear-gradient(180deg, #FFFFFF 0%, #F4F4F4 100%);
}
.section {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  padding-left: 1.875rem;
  padding-right: 1.875rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.section_head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.section_head::before {
  content: "";
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  display: inline-block;
  height: 1em;
  width: 0.25rem;
}
.section_head_title {
  font-weight: 500;
  margin-left: 0.625rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.product-date {
  align-items: center !important;
}
.scrollNav {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-left: 1.875rem;
  padding-right: 1.5rem;
  width: 100%;
}
.scrollNav_container {
  height: 4rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  top: var(--app-header-height);
  z-index: 10;
}
.scrollNav_fixed {
  border-bottom-width: 1px;
}
.scrollNav_item {
  cursor: pointer;
  height: 4rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 4rem;
  position: relative;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.scrollNav_item + .scrollNav_item {
  margin-left: 1.75rem;
}
.scrollNav_item::after {
  content: "";
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.125rem;
  height: 0.25rem;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.scrollNav_item.isActive {
  font-weight: 500;
}
.scrollNav_item.isActive::after {
  background-color: currentColor;
}
.tour_btn {
  border: 1px solid var(--border-color-darker);
  color: $color-black-2;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  align-self: center;
  height: 40px;
  padding: 0 12px 0 10px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
.tour_btn em {
  display: inline-block;
  vertical-align: middle;
  margin-top: -10px;
}
.material_icon {
  width: 27px;
  height: 22px;
  vertical-align: middle;
}
.font_24 {
  font-size: 24px;
}
</style>
